import { GoogleAuthProvider, signInWithRedirect } from 'firebase/auth';

const HandleGoogle = async (auth) => {
  const provider = new GoogleAuthProvider();
  try {
    await signInWithRedirect(auth, provider);
  } catch(e) {
    console.error('Google authentication error', e);
  }
};

export default HandleGoogle;
